module.exports = __webpack_public_path__ + "static/media/comment-filled.564dfb2f.svg";